import { useRef, useState } from "react";
import { Bell } from "lucide-react";
import { NotificationPanel } from "../../destek/components/NotificationPanel";
import {
  type NotificationFilter,
  useCustomerNotifications,
} from "../../destek/hooks/useCustomerNotifications";
import { useLanguage } from "../../contexts/LanguageContext";
export function NotificationCenter({
  supportBase = "/support",
}: {
  supportBase?: string;
}) {
  const [open, setOpen] = useState(false),
    [filter, setFilter] = useState<NotificationFilter>("all"),
    triggerRef = useRef<HTMLButtonElement>(null),
    notifications = useCustomerNotifications(filter),
    { language, t } = useLanguage();
  const count =
      notifications.unreadCount > 99
        ? "99+"
        : String(notifications.unreadCount),
    label = notifications.unreadCount
      ? language === "tr"
        ? `${notifications.unreadCount} okunmamış bildirim`
        : `${notifications.unreadCount} unread notifications`
      : t("destek_bell_aria_empty");
  return (
    <div className="relative">
      <button
        ref={triggerRef}
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={label}
        aria-haspopup="dialog"
        aria-expanded={open}
        className={`relative inline-flex min-h-11 min-w-11 items-center justify-center rounded-md border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/60 ${open ? "border-brand-400/50 bg-brand-500/15 text-white" : "border-white/5 bg-white/[0.03] text-slate-400 hover:border-brand-400/30 hover:text-white"}`}
      >
        <Bell aria-hidden size={17} />
        {notifications.unreadCount > 0 && (
          <span
            aria-hidden
            className="absolute -right-1.5 -top-1.5 inline-flex min-w-5 items-center justify-center rounded-full border border-dark-900 bg-brand-400 px-1 text-[10px] font-bold leading-5 text-dark-900"
          >
            {count}
          </span>
        )}
      </button>
      <NotificationPanel
        open={open}
        bellRef={triggerRef}
        filter={filter}
        onFilterChange={setFilter}
        notifications={notifications}
        onClose={() => setOpen(false)}
        resolveIssueHref={(id) =>
          `${supportBase}/issue/${encodeURIComponent(id)}`
        }
      />
    </div>
  );
}
